<template>
  <div class="leader" id="leaders">
    <el-row>
      <el-col :span="24" class="leader-title">领袖风采</el-col>
      <el-col :span="24" class="leader-line"></el-col>
      <el-col :span="24" class="leader-style">Leadership style</el-col>
    </el-row>
    <div
      v-if="swiperShow"
      class="leader-right"
      @mouseenter="$refs.mySwiper.$swiper.autoplay.stop()"
      @mouseleave="$refs.mySwiper.$swiper.autoplay.start()"
    >
      <swiper v-if="swiperDatas" :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item,index) in swiperDatas" :key="'leader-'+index">
          <div class="leader-images">
            <div class="leader-img">
              <img :src="item.hero_image" alt />
            </div>
            <div class="personal">
              <div class="userName">{{item.name_ch}}</div>
              <div class="user-line"></div>
              <div class="userInformation">
                <div>{{item.remark}}</div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
const leaderListUri = "website/index/leader/get/all";

export default {
  data() {
    return {
      swiperShow: false,
      swiperOption: {
        speed: 2000,
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
        loop: false,
        autoplay: {
          delay: 1000
        }
      },
      swiperDatas: []
    };
  },
  methods: {},
  created() {
    this.initConfig();
    this.getLeaderList();
  },
  methods: {
    // 初始化配置
    initConfig() {
      let config = this.$cache.get("leaderConfig");
      if (config) {
        this.swiperOption.autoplay.delay = config.interval_time;
      }
    },
    // 获取领导列表
    getLeaderList() {
      this.$api.get(leaderListUri).then(res => {
        if (res.list.length > 3) {
          this.swiperOption.loop = true;
        }
        this.swiperDatas = res.list;
        this.swiperShow = true;
      });
    },
    // 初始化轮播事件
    initEvent() {
      let images = document.querySelectorAll(".leader-images");
      images.forEach(_ => {
        _.onmouseenter = function() {
          _.querySelector(".personal").style.opacity = 1;
        };
        _.onmouseleave = function() {
          _.querySelector(".personal").style.opacity = 0;
        };
      });
    }
  },
  watch: {
    swiperDatas() {
      this.$nextTick(() => {
        this.initEvent();
      });
    }
  }
};
</script>
<style lang="less" scoped>
.leader {
  width: 1200px;
  background: #fff;
  margin: 0 auto;
  margin-top: 36px;
  display: flex;
  .el-row {
    width: 276px;
    height: 273px;
    padding: 66px 0 66px 48px;
    .leader-title {
      font-size: 30px;
      font-weight: 500;
      color: #333333;
    }
    .leader-line {
      width: 24px;
      height: 2px;
      background: #e60616;
      margin: 32px 0 36px 0;
    }
    .leader-style {
      font-size: 24px;
      color: #999999;
    }
  }
  .leader-right {
    width: 924px;
    .swiper-slide {
      width: 273px;
      .leader-images {
        position: relative;
        width: 273px;
        .leader-img {
          width: 273px;
          height: 273px;
          img {
            width: 273px;
            height: 273px;
          }
        }
        .personal {
          position: absolute;
          bottom: 0;
          width: 273px;
          height: 160px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.8) 100%
          );
          padding: 24px;
          opacity: 0;
          transition: opacity 1s;
          .userName {
            font-size: 18px;
            font-weight: 500;
            color: #fff;
          }
          .user-line {
            width: 24px;
            height: 2px;
            background: #fff;
            margin: 16px 0 20px 0;
          }
          .userInformation {
            font-size: 14px;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>


